import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { makeGetCurrentUserId, makeGetCurrentUser } from 'selectors/users';

const getCurrentUserId = makeGetCurrentUserId();

export const useCurrentUserId = () => {
    const currentUserId = useSelector(({ users }) => getCurrentUserId(users));

    return currentUserId;
};

const getCurrentUser = makeGetCurrentUser();

export const useCurrentUser = () => {
    const currentUser = useSelector(({ users }) => getCurrentUser(users));

    return currentUser;
};
